import thdCustomer from '@thd-olt-global/thd-customer';
import { isMobile } from 'react-device-detect';
import { api } from './base';
import { getTMXSessionID } from '../utils';

export function getCustomerRecentActivity() {
  const activityRequest = {
    method: 'get',
    url: `/customer/account/v1/${thdCustomer?.userID}/activity`,
    headers: {
      Accept: 'application/json',
      Channelid: isMobile ? '2' : '1',
      Authorization: thdCustomer.jwt,
      TMXProfileID: getTMXSessionID(),
      ClientOrigin: window.location.origin,
    },
  };

  return api(activityRequest)
    .then((res) => {
      return res?.data?.events;
    })
    .catch(() => {
      return null;
    });
}
